import * as contracts from '@appStore/contracts/actions/contracts.actions';
import * as budgets from '@appStore/contracts/actions/budgets.actions';
import * as agreements from '@appStore/contracts/actions/agreement.actions';
import * as serviceAgreements from '@appStore/contracts/actions/service-agreements.actions';

export * from '@appStore/contracts/actions/contracts.actions';
export * from '@appStore/contracts/actions/budgets.actions';
export * from '@appStore/contracts/actions/agreement.actions';
export * from '@appStore/contracts/actions/service-agreements.actions';

export const ActionTypes = {
  ...contracts.ContractsActionTypes,
  ...budgets.BudgetsActionTypes,
  ...agreements.AgreementActionTypes,
  ...serviceAgreements.ServiceAgreementsActionTypes 
};

export type Actions = 
contracts.ContractsActions |
budgets.BudgetsActions | 
agreements.AgreementActions | 
serviceAgreements.ServiceAgreementsActions;
